export const getProfileDisplay = (user) => {
	const name = user?.name?.trim() || '';
	const email = user?.email?.trim() || '';
	const initialSource = name || email || 'U';

	return {
		name,
		email,
		initial: initialSource.charAt(0).toUpperCase(),
	};
};

export const mergeProfileData = (currentProfile, apiProfile) => ({
	name: apiProfile?.name?.trim() || currentProfile?.name || '',
	email: apiProfile?.email?.trim() || currentProfile?.email || '',
	joinedDate: apiProfile?.joinedDate ?? currentProfile?.joinedDate ?? null,
	planExpiry: apiProfile?.planExpiry ?? currentProfile?.planExpiry ?? null,
});
